import React, { useState } from "react";
import PropTypes from "prop-types";
import { FiUser, FiChevronUp, FiChevronDown } from "react-icons/fi";

import {
  AccordionHeader,
  AccordionLabel,
  Chevron,
  AccordionContent,
  DataText,
} from "../styles";

function formatPhone(phone) {
  if (!phone) return "";
  const digits = phone.replace(/\D/g, "");
  if (digits.length === 11) {
    return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7)}`;
  }
  if (digits.length === 10) {
    return `(${digits.slice(0, 2)}) ${digits.slice(2, 6)}-${digits.slice(6)}`;
  }
  return phone;
}

export default function PersonalDataAccordion({ user }) {
  const [open, setOpen] = useState(true); // inicia aberto (spec)

  return (
    <div>
      <AccordionHeader type="button" onClick={() => setOpen((v) => !v)}>
        <AccordionLabel>
          <FiUser />
          Dados pessoais
        </AccordionLabel>
        <Chevron>{open ? <FiChevronUp /> : <FiChevronDown />}</Chevron>
      </AccordionHeader>

      {open && (
        <AccordionContent>
          {user?.nome && <DataText>{user.nome}</DataText>}
          {user?.telefone && <DataText>{formatPhone(user.telefone)}</DataText>}
          {user?.email && <DataText>{user.email}</DataText>}
        </AccordionContent>
      )}
    </div>
  );
}

PersonalDataAccordion.propTypes = {
  user: PropTypes.object,
};
